<template>
    <div>
        <Pie :data="chartData" :options="options" />
    </div>
</template>
    
<script>

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'vue-chartjs';

ChartJS.register(ArcElement, Tooltip, Legend);

import { computed } from 'vue';

export default {
    name: 'investment-plan-summary-chart',
    components: {Pie},
    props: {
        row: {type: Array},
    },
    data() {
    return {
        options: {
            responsive: true,
            maintainAspectRatio: false,
        },
        data: [],
    }
    },
    methods: {
        
    },
    onMounted() {
        const row  = this.props.row;
        this.data = row;
    },
    mounted() {
        
    },
    setup(props) {
    const chartData = computed(() => {
        const { row } = props;
        let data = {
          labels: [],
          datasets: []
        };
        let datasets = [];
        row.forEach(element => {
            data.labels.push(element.investment_type.name);
            datasets.push(element.invest);
        });

        data.datasets.push({'data': datasets, 'backgroundColor': ['#2563EB', '#16A34A', '#D97706', '#7C3AED', '#0EA5E9', '#DC2626']});
        return data;
    });
    return { chartData };
    },
}
</script>